module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/121-new-zealand-c532ca348b4e3ee94886b750c56f4a7e.svg";